import React from "react";
import { Grid, IconButton } from "@mui/material";
import Typography from "@mui/material/Typography";
import AddIcon from "@mui/icons-material/AddCircleOutline";
import { TicketProps } from "../../FlightPackage/Ticket/FlightLegs/ticketFlightLegs";
import TimeCalculator from "../../sharedCode/TimeCalculator";
import { TicketLocationExtended } from "../../Utils/TypeExtensions";
import { addLocation } from "../../Utils/TicketDatabase";

export default function UpDownFooter(props: TicketProps): JSX.Element {
    const totalHours = TimeCalculator.getTotalFlightTimeFormatted(props.ticket);

    return (
        <Grid container flexDirection={"row"} sx={{ marginTop: 2 }}>
            <Grid item container xs={10}>
                <Grid item xs={1}>
                    <IconButton disabled={props.isReadOnly} size="large" color="inherit" onClick={handleAddClicked}>
                        <AddIcon />
                    </IconButton>
                </Grid>
                <Grid item xs={11}>
                    <Typography sx={{ textAlign: "right" }}>TOTAL FLIGHT HOURS</Typography>
                </Grid>
            </Grid>
            <Grid item xs={2}>
                <Grid item xs={8}>
                    <Typography sx={{ textAlign: "right" }}>{totalHours}</Typography>
                </Grid>
                <Grid item xs={4}></Grid>
            </Grid>
        </Grid>
    );

    function handleAddClicked(): void {
        const id = props.ticket.nextLocalId;
        const sortOrder = props.ticket.Locations ? props.ticket.Locations.length : 0;
        const newLocation = {
            id: id,
            location: "",
            ticket_id: props.ticket.id,
            sort_order: sortOrder,
        } as TicketLocationExtended;

        addLocation(props.ticket.id, newLocation).catch(() => props.showForceReloadDialogue());
    }
}
